import DialogHeader from '../components/DialogHeader/DialogHeader';
import { styled } from '@mui/material/styles';
import { dialogClasses } from '../dialogClasses';
import { dialogContentClasses } from '@mui/material/DialogContent';

export const MessageDialogRoot = styled('div', { name: 'AFMessageDialog' })(
  ({ theme }) => ({
    [`& .${dialogContentClasses.root}`]: {
      marginBottom: theme.spacing(3)
    },
    [`& .${dialogClasses.cancelButton}`]: {
      '&.alert': {
        color: theme.palette.grey[700]
      }
    }
  })
);

export const MessageDialogHeader = styled(DialogHeader)(({ theme }) => ({
  paddingBottom: theme.spacing(2)
}));
